
import {debounceTime} from 'rxjs/operators';
/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import * as _ from 'lodash';

import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

import { AppUtilityService } from './../../../core/services/app-utility.service';
import { ConfigService } from '../../../core/services/config.service';
import { LmsLoaderService } from '../../../core/services/lms-loader.service';
import { LmsModuleService } from '../../../core/services/lms-module.service';
import { LmsRendererService } from '../../../core/services/lms-renderer.service';
import { LocoDetail } from './../../../core/model/loco-detail.model';
import { MessageHandlerService } from './../../../core/services/message-handler.service';
import { Router } from '@angular/router';
import { TabSearchParameter } from '../../../core/model/tab-search-parameter.model';
import { TabService } from '../../../core/services/tab.service';
import { TerminalConfigService } from './../../shared/services/terminal-config.service';
import { TerminalHandlingInboundDisplay } from './../../shared/model/terminal-handling-inbound-display.model';
import { ChangeDetectorRef } from '@angular/core';

/**
 * @export
 * @class LmsTerminalInboundListComponent
 * @implements {OnInit}
 * @implements {OnChanges}
 */
@Component({
  selector: 'lms-terminal-inbound-list',
  templateUrl: './lms-terminal-inbound-list.component.html',
  styleUrls: ['./lms-terminal-inbound-list.component.scss']
})
export class LmsTerminalInboundListComponent implements OnInit, OnChanges {

  totalLocoCount = 0;
  serviceCtrShopRecordCount = 0;
  mainTrackRecordCount = 0;
  truckFuelRecordCount = 0;
  toStorageRecordCount = 0;
  nextAssignmentRecordCount = 0;
  totalLocoCountClass: string;
  serviceCenterCountClass: string;
  mainTrackCountClass: string;
  truckFuelCountClass: string;
  toStorageCountClass: string;
  nextAssignmentCountClass: string;
  @Input() totalInboundTrainsArr: Array<TerminalHandlingInboundDisplay>;
  @Input() terminalHandlingSearchText: string;
  totalSearchedInboundTrainsArr: Array<TerminalHandlingInboundDisplay> = [];
  inboundTrainsArr: any = [];
  scrollDivHeight: string;
  upperHeight = 314;
  selectedFilter: string;
  inboundFilterLabel: any;
  inboundTable: any;
  rowsPerPage;
  rowHeight = 50;
  @Output() onLocoSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() showContextMenu: EventEmitter<any> = new EventEmitter<any>();
  @Output() hideLocoContextMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
  isSearchApplied: boolean;
  /**
   * Creates an instance of LmsTerminalInboundListComponent.
   * @memberOf LmsTerminalInboundListComponent
   */
  constructor(private configService: ConfigService,
    private lmsModuleService: LmsModuleService,
    private terminalConfigService: TerminalConfigService,
    private router: Router, private lmsLoaderService: LmsLoaderService,
    private lmsRendererService: LmsRendererService,
    private appUtilityService: AppUtilityService,
    private tabService: TabService,
    private cdr: ChangeDetectorRef, 
    private messageHandlerService: MessageHandlerService) {
    this.lmsRendererService.resizeObervable.pipe(debounceTime(10)).subscribe((isResize) => {
      if (isResize) {
        const newRowsPerPage = this.appUtilityService.getRowPerPageCount(111.6, this.upperHeight);
        if (newRowsPerPage !== this.rowsPerPage) {
          this.rowsPerPage = newRowsPerPage;
          this.resetDataScroller();
        }
      }
    });
  }

  /**
   * initialize the state of lifecycle hook.
   * @memberOf LmsTerminalInboundListComponent
   */
  ngOnInit() {
    this.rowsPerPage = this.appUtilityService.getRowPerPageCount(111.6, this.upperHeight);
    this.inboundFilterLabel = this.terminalConfigService.terminalConfigData.subTypes.handling.inbound.filterLabel;
    this.inboundTable = this.terminalConfigService.terminalConfigData.subTypes.handling.inbound.table;
    this.selectedFilter = 'totalLoco';
    this.calculatePageHeight();
    if (this.totalInboundTrainsArr) {
      this.setLocomotiveFilterCount(this.totalInboundTrainsArr);

      // FIX: Ensure data is loaded for the default filter on initial load
    this.inboundTrainsArr = this.getTotalFilteredLocomotive(
      this.totalInboundTrainsArr,
      this.selectedFilter
      );
    }
  }

  /**
   * Calculate page height for page level scroll.
   *
   * @private
   * @memberof LmsTerminalInboundListComponent
   */
  private calculatePageHeight() {
    let heightToAdjust = 0;
    if (this.lmsRendererService.getWindowWidth() < 1280) {
      heightToAdjust = 27;
    }
    this.scrollDivHeight = (this.lmsRendererService.getWindowHeight() - this.upperHeight - heightToAdjust) + 'px';
  }

  /**
   * @memberOf LmsTerminalInboundListComponent
   */
  ngOnChanges() {
    this.rowsPerPage = this.appUtilityService.getRowPerPageCount(111.6, this.upperHeight);
    if (this.terminalHandlingSearchText && this.terminalHandlingSearchText.length > 0) {
      this.setTotalSearchedInboundTrainsArr(this.terminalHandlingSearchText, this.totalInboundTrainsArr);
    } else {
      this.isSearchApplied = false;
      this.inboundTrainsArr = this.removeDuplicates(this.totalInboundTrainsArr, 'trainId');
      if (this.totalInboundTrainsArr && this.inboundFilterLabel) {
        this.setLocomotiveFilterCount(this.totalInboundTrainsArr);
      }
    }
  }

  /**
   * Hide loco context panel from screen.
   * @memberof LmsTerminalInboundListComponent
   */
  public hideLocoContextPanel() {
    this.hideLocoContextMenu.emit(true);
  }

  /**
   * Invoked when scroll is performed on data scroller.
   * @param {any} event
   * @memberOf LmsTerminalInboundListComponent
   */
  loadInboundTrainsLazy(event) {
    console.log('Inbound Trains:', this.inboundTrainsArr);
    this.hideLocoContextPanel();
    let filteredLocomotiveArr = [];
    if (this.isSearchApplied) {
      filteredLocomotiveArr = this.getTotalFilteredLocomotive(this.totalInboundTrainsArr, this.selectedFilter);
    } else {
      filteredLocomotiveArr = this.getTotalFilteredLocomotive(this.totalInboundTrainsArr, this.selectedFilter);
    }
    filteredLocomotiveArr = this.removeDuplicates(filteredLocomotiveArr, 'trainId');
    for (let i = event.first; i < filteredLocomotiveArr.length; i++) {
      if (this.inboundTrainsArr.indexOf(filteredLocomotiveArr[i]) < 0) {
        this.inboundTrainsArr.push(filteredLocomotiveArr[i]);
      }
    }
    this.inboundTrainsArr = this.removeDuplicates(filteredLocomotiveArr, 'trainId');
  }

  /**
   * Reset data from data scroller.
   *
   * @memberof LmsTerminalInboundListComponent
   */
  resetDataScroller() {
    this.hideLocoContextPanel();

    // Determine the source array to filter
    let filteredLocomotiveArr = [];
    if (this.isSearchApplied) {
        filteredLocomotiveArr = this.getTotalFilteredLocomotive(this.totalSearchedInboundTrainsArr, this.selectedFilter);
    } else {
        filteredLocomotiveArr = this.getTotalFilteredLocomotive(this.totalInboundTrainsArr, this.selectedFilter);
    }

    // Remove duplicates from the filtered array
    filteredLocomotiveArr = this.removeDuplicates(filteredLocomotiveArr, 'trainId');

    // Update the displayed data
    if (filteredLocomotiveArr && filteredLocomotiveArr.length > 0) {
        this.inboundTrainsArr = [...filteredLocomotiveArr.slice(0, this.rowsPerPage)];
    } else {
        console.warn('No data found for the selected filter or search criteria.');
        this.inboundTrainsArr = []; // Clear the displayed data if no results
    }

    // Trigger change detection to update the UI
    this.cdr.detectChanges();
}

  /**
   * Invoked when particular filter is selected from top of the data scroller.
   * @param {string} filterName
   * @memberOf LmsTerminalInboundListComponent
   */
  setSelectedFilter(filterName: string) {
    this.selectedFilter = filterName;
    let filteredLocomotiveArr = [];
    if (this.isSearchApplied) {
      filteredLocomotiveArr = this.getTotalFilteredLocomotive(this.totalSearchedInboundTrainsArr, this.selectedFilter);
    } else {
      filteredLocomotiveArr = this.getTotalFilteredLocomotive(this.totalInboundTrainsArr, this.selectedFilter);
    }

    if (filteredLocomotiveArr && filteredLocomotiveArr.length > 0) {
      this.inboundTrainsArr = filteredLocomotiveArr;
      this.totalLocoCountClass = (filterName === 'totalLoco') ?
        'active' : ((this.totalLocoCountClass === 'disabled') ? 'disabled' : '');
      this.serviceCenterCountClass = (filterName === 'S') ?
        'active' : ((this.serviceCenterCountClass === 'disabled') ? 'disabled' : '');
      this.mainTrackCountClass = (filterName === 'M') ?
        'active' : ((this.mainTrackCountClass === 'disabled') ? 'disabled' : '');
      this.truckFuelCountClass = (filterName === 'T') ?
        'active' : ((this.truckFuelCountClass === 'disabled') ? 'disabled' : '');
      this.toStorageCountClass = (filterName === 'X') ?
        'active' : ((this.toStorageCountClass === 'disabled') ? 'disabled' : '');
      this.nextAssignmentCountClass = (filterName === 'nextAssignment') ?
        'active' : ((this.nextAssignmentCountClass === 'disabled') ? 'disabled' : '');

    }
  }

  /**
   * Invoked for removing dublicate object with particular property.
   * @param {any} myArr
   * @param {any} prop
   * @returns
   * @memberOf LmsTerminalInboundListComponent
   */
  removeDuplicates(myArr, prop) {
    return _.uniqBy(myArr, prop);
  }

  /**
   * this method is used to navigate the user to locomotive screen
   * when click on locomotive id.
   * @param {string} subType
   * @param {string} type
   * @memberOf LmsTerminalInboundListComponent
   */
  public showLocomotiveTabData(subType: string, type: string, locomotiveIdentifier: string) {
    const tabSearchParameter = <TabSearchParameter>({ searchText: this.formatLocomotiveId(locomotiveIdentifier) });
    window.open(
      window.location.href.split('?')[0] + '?type='+ type.toLowerCase() +'&subtype=' + subType.toLowerCase() + '&search=' + tabSearchParameter.searchText,
      '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
    );
  }

  /**
   * this method is used to navigate the user to train screen
   * @param {string} subType
   * @param {string} type
   * @memberOf LmsTerminalInboundListComponent
   */
  public showTrainTabData(subType: string, type: string, trainIdentifier: string) {
    const tabSearchParameter = <TabSearchParameter>({ searchText: trainIdentifier });
    window.open(
      window.location.href.split('?')[0] + '?type=train&subtype=' + subType.toLowerCase() + '&search=' + tabSearchParameter.searchText,
      '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
    );
  }

  /**
  * Format the locomotive id
  * @private
  * @param {string} value
  * @returns {string}
  * @memberOf LmsTerminalInboundListComponent
  */
  private formatLocomotiveId(value: string): string {
    if (value) {
      value = value.trim();
      const v = value.match(/\d+/);
      if (v) {
        const locoInitial = (v.index <= 4) ? value.substring(0, v.index).trim() : value.substring(0, 4).trim();
        const locoNumber = (v.index <= 4) ? value.substring(v.index, value.length).trim() : value.substring(4, value.length).trim();
        return locoInitial + ' ' + locoNumber.replace(/^0+/, '');
      }
    }
  }

  /**
   * Get locomotive list according to filter type.
   *
   * @param {Array<TerminalHandlingInboundDisplay>} totalInboundTrainsArr
   * @param {string} filterType
   * @returns {Array<TerminalHandlingInboundDisplay>}
   *
   * @memberOf LmsTerminalInboundListComponent
   */
  getTotalFilteredLocomotive(totalInboundTrainsArr: Array<TerminalHandlingInboundDisplay>,
    filterType: string): Array<TerminalHandlingInboundDisplay> {

    let filteredLocomotiveArray: Array<TerminalHandlingInboundDisplay> = [];
    const temp = JSON.parse(JSON.stringify(totalInboundTrainsArr));

    if (filterType === 'totalLoco') {
      filteredLocomotiveArray = temp.filter((totalInboundTrains) => {
        const tempLocomotiveArr = totalInboundTrains.locomotiveArr.filter((locomotive) => {
          return true;
        });
        if (tempLocomotiveArr && tempLocomotiveArr.length > 0) {
          totalInboundTrains.locomotiveArr = tempLocomotiveArr;
          return true;
        }
      });
    } else if (filterType === 'nextAssignment') {
      filteredLocomotiveArray = temp.filter((totalInboundTrains) => {
        const tempLocomotiveArr = totalInboundTrains.locomotiveArr.filter((locomotive) => {
          return (locomotive.plannedAssignment && locomotive.plannedAssignment.trim() !== '');
        });
        if (tempLocomotiveArr && tempLocomotiveArr.length > 0) {
          totalInboundTrains.locomotiveArr = tempLocomotiveArr;
          return true;
        }
      });
    } else {
      filteredLocomotiveArray = temp.filter((totalInboundTrains) => {
        const tempLocomotiveArr = totalInboundTrains.locomotiveArr.filter((locomotive) => {
          return (locomotive.thpTypeCode === filterType);
        });
        if (tempLocomotiveArr && tempLocomotiveArr.length > 0) {
          totalInboundTrains.locomotiveArr = tempLocomotiveArr;
          return true;
        }
      });
    }
    return filteredLocomotiveArray;
  }

  /**
   * This shows Locomotive Context Menu
   * @memberOf LmsTerminalInboundListComponent
   */
  public showLocomotiveContextMenu(locomotiveIdentifier: string, actualLocomotiveId: string, index: string) {
    const loco: LocoDetail = {
      locomotiveIdentifier: locomotiveIdentifier,
      actualLocomotiveId: actualLocomotiveId
    };
    this.lmsLoaderService.showLoader();
    this.onLocoSelect.emit({ loco: loco, index: index });
  }

  /**
   * set count on filter for inbound section of terminal handling.
   * @private
   * @param {Array<TerminalHandlingInboundDisplay>} totalInboundTrainsArr
   * @memberOf LmsTerminalInboundListComponent
   */
  private setLocomotiveFilterCount(totalInboundTrainsArr: Array<TerminalHandlingInboundDisplay>) {
    if (this.inboundFilterLabel) {
      this.totalLocoCount = totalInboundTrainsArr.reduce(function (prevVal, elem) {
        return prevVal + elem.locomotiveArr.length;
      }, 0);

      const serviceCtrShopArray = this.getTotalFilteredLocomotive(totalInboundTrainsArr, 'S');
      this.serviceCtrShopRecordCount = this.getLocomotiveCountFromArray(serviceCtrShopArray);

      const mainTrackArray = this.getTotalFilteredLocomotive(totalInboundTrainsArr, 'M');
      this.mainTrackRecordCount = this.getLocomotiveCountFromArray(mainTrackArray);

      const truckFuelArray = this.getTotalFilteredLocomotive(totalInboundTrainsArr, 'T');
      this.truckFuelRecordCount = this.getLocomotiveCountFromArray(truckFuelArray);

      const toStorageArray = this.getTotalFilteredLocomotive(totalInboundTrainsArr, 'X');
      this.toStorageRecordCount = this.getLocomotiveCountFromArray(toStorageArray);

      const nextAssignmentArray = this.getTotalFilteredLocomotive(totalInboundTrainsArr, 'nextAssignment');
      this.nextAssignmentRecordCount = this.getLocomotiveCountFromArray(nextAssignmentArray);

      this.totalLocoCountClass = (this.totalLocoCount === 0) ? 'disabled' : 'active';
      this.serviceCenterCountClass = (this.serviceCtrShopRecordCount === 0) ? 'disabled' : '';
      this.mainTrackCountClass = (this.mainTrackRecordCount === 0) ? 'disabled' : '';
      this.truckFuelCountClass = (this.truckFuelRecordCount === 0) ? 'disabled' : '';
      this.toStorageCountClass = (this.toStorageRecordCount === 0) ? 'disabled' : '';
      this.nextAssignmentCountClass = (this.nextAssignmentRecordCount === 0) ? 'disabled' : '';
    }
  }

  /**
   * Navigate to terminal status screen.
   *
   * @param {string} subType
   * @param {string} type
   * @param {string} terminalMnemonic
   *
   * @memberOf LmsTerminalInboundListComponent
   */
  public showTerminalTabData(subType: string, type: string, terminalMnemonic: string) {
    const tabSearchParameter = <TabSearchParameter>({ searchText: terminalMnemonic });
    window.open(
      window.location.href.split('?')[0] + '?type='+ type.toLowerCase() +'&subtype=' + subType.toLowerCase() + '&search=' + tabSearchParameter.searchText,
      '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
    );
  }
  /**
   * @param {*} inboundLocomotiveArr
   * @returns {number}
   * @memberOf LmsTerminalInboundListComponent
   */
  getLocomotiveCountFromArray(inboundLocomotiveArr: any): number {
    let locomotiveCount = 0;
    if (inboundLocomotiveArr) {
      locomotiveCount = inboundLocomotiveArr.reduce(function (prevVal, elem) {
        return prevVal + elem.locomotiveArr.length;
      }, 0);
    }
    return locomotiveCount;
  }

  /**
   * Redirect to train data or terminal status screen.
   *
   * @param {string} value
   *
   * @memberOf LmsTerminalInboundListComponent
   */
  redirectToTrainOrTerminal(value: string) {
    if (value) {
      if (this.isTrainId(value)) {
        this.showTrainTabData('Data', 'Train', value);
      } else {
        this.showTerminalTabData('Status', 'Terminal', value);
      }
    }
  }

  /**
   * Check for train id.
   *
   * @param {string} value
   * @returns {boolean}
   *
   * @memberOf LmsTerminalInboundListComponent
   */
  isTrainId(value: string): boolean {
    let flag = false;
    if (value && value.length > 0) {
      if (!this.isNumeric(value.charAt(0))) {
        const remainingStr = value.substring(1, value.length);
        if (this.isNumeric(remainingStr)) {
          flag = true;
        }
      }
    }
    return flag;
  }
  /**
    * To check whether string is a number or not
    * @private
    * @param {string} value
    * @returns {boolean}
    * @memberOf LmsTerminalOnTerminalListComponent
    */
  private isNumeric(value: string): boolean {
    const v = value.match(/^\d+$/);
    if (v) {
      if (v.toString() === value) {
        return true;
      }
    }
    return false;
  }
  /**
   * Set inbound array through search parameter.
   * @private
   * @param {string} terminalHandlingSearchText
   * @param {Array<TerminalHandlingInboundDisplay>} totalInboundTrainsArr
   * @memberOf LmsTerminalInboundListComponent
   */
  private setTotalSearchedInboundTrainsArr(terminalHandlingSearchText: string,
    totalInboundTrainsArr: Array<TerminalHandlingInboundDisplay>) {
    this.totalSearchedInboundTrainsArr = [];
    this.isSearchApplied = true;
    this.totalSearchedInboundTrainsArr = totalInboundTrainsArr.filter((terminalHandlingDisplay) => {
      return (terminalHandlingDisplay.trainId === this.terminalHandlingSearchText);
    });

    for (let i = 0; i < totalInboundTrainsArr.length; i++) {
      const locomotiveArr = [];
      for (let j = 0; j < totalInboundTrainsArr[i].locomotiveArr.length; j++) {
        if (totalInboundTrainsArr[i].locomotiveArr[j].locomotiveId &&
          totalInboundTrainsArr[i].locomotiveArr[j].locomotiveId === terminalHandlingSearchText) {

          locomotiveArr.push(totalInboundTrainsArr[i].locomotiveArr[j]);
        }
        if (totalInboundTrainsArr[i].locomotiveArr[j].plannedAssignment &&
          totalInboundTrainsArr[i].locomotiveArr[j].plannedAssignment === terminalHandlingSearchText) {

          locomotiveArr.push(totalInboundTrainsArr[i].locomotiveArr[j]);
        }
      }
      if (locomotiveArr && locomotiveArr.length > 0) {
        const terminalHandlingDisplay = {
          trainId: totalInboundTrainsArr[i].trainId,
          inboundTrainETA: totalInboundTrainsArr[i].inboundTrainETA,
          locomotiveArr: locomotiveArr
        };
        this.totalSearchedInboundTrainsArr.push(terminalHandlingDisplay);
      }

    }
    this.totalSearchedInboundTrainsArr = this.removeDuplicates(this.totalSearchedInboundTrainsArr, 'trainId');

    if (this.totalSearchedInboundTrainsArr && this.inboundFilterLabel) {
      this.setLocomotiveFilterCount(this.totalSearchedInboundTrainsArr);
      this.inboundTrainsArr = this.totalSearchedInboundTrainsArr;
    }
  }

  /**
   * Redirect to tab according to type, subType and search text.
   * @param {string} type
   * @param {string} subType
   * @param {string} searchText
   * @memberof LmsTerminalInboundListComponent
   */
  redirectToTab(type: string, subType: string, searchText: string) {
    this.appUtilityService.navigateByUrl(type, subType, searchText, true);
  }
  /**
     * Check value is terminal or not for displaying ETD.
     *
     * @param {string} value
     * @returns {boolean}
     * @memberof LmsTerminalInboundListComponent
     */
  isEtdDisplay(value: string): boolean {
    let flag = true;
    if (value && this.appUtilityService.isValidTerminalId(value)) {
      flag = false;
    }
    return flag;
  }

  showContextMenuLinks(event, type: string, id: string, value: string) {
    let contextMenu;
    if (type) {
      if ('MIX' === type.toUpperCase()) {
        let typeTemp;
        if (this.isTrainId(value)) {
          typeTemp = 'Train';
        } else {
          typeTemp = 'Terminal';
        }
        contextMenu = {
          id: id,
          type: typeTemp,
          value: value,
          event: event
        };
      } else {
        contextMenu = {
          id: id,
          type: type,
          value: value,
          event: event
        };
      }
      this.showContextMenu.emit(contextMenu);
    }
  }
}
